import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

interface IProps {
    priceColor: COLORS,
    count?: string,
    discount: number,
    price: number,
}

export const MultibundlePrice = ({ priceColor, count, discount, price }: IProps): JSX.Element => {
    return <ST.CountPrice>
        <ST.DiscountLabel
            textColor={COLORS.TextWhite}
            bgColor={priceColor}
        >
            <ST.DiscountUpTo>до</ST.DiscountUpTo>
            <ST.DiscountValue>- {discount}%</ST.DiscountValue>
        </ST.DiscountLabel>
        <ST.Count textColor={priceColor}>{count}+ 1</ST.Count>
        <ST.Price>{price} ₽/мес</ST.Price>
    </ST.CountPrice>;
};
